const isAIEnhancedPreviewItem = (previewItem = {}) => previewItem.assistantEligible === true;

export default isAIEnhancedPreviewItem;
